import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CertificateDetails } from '../../../features/certificate/model/certificate-details';
import { HttpProvider } from '../../common/http/http-provider.service';
import { CertiticateFilterDTO } from '../../../features/certificate/model/certificate-filter';

@Injectable()
export class CertificateDataRepository extends HttpProvider {
  constructor(http: HttpClient) {
    super(http);
  }

  saveCertificateDetails(cerDetails: CertificateDetails) {
    if (!cerDetails.id || cerDetails.id == 0)
      return this.post('certificate/SaveCerDetails', cerDetails);
    else
      return this.put('certificate/UpdateDetails', cerDetails);
    // if (!parameter.id) return this.post('cerDetails', parameter);
    // else return this.put('cerDetails/' + parameter.id, parameter);
  }

  getCertificateDetails(id: any) {
    return this.get('certificate/getCertificate/' + id);
  }
  getCertificateOverview(id: any) {
    return this.get('certificate/overview/' + id);
  }

  saveResults(parameter: any) {
    if (!parameter.id || parameter.id == 0)
      return this.post('certificateResult', parameter);
    else return this.put('certificateResult/' + parameter.id, parameter);
  }
  //here actual API will have array of elements

  saveElement(parameter: any) {
    if (!parameter.id || parameter.id == 0)
      return this.post(
        'constructionElement/SaveConstructionElement',
        parameter
      );
    else
      return this.put(
        'constructionElement/UpdateConstructionElement/' + parameter.id,
        parameter
      );
    // return this.post('testElement', parameter);
  }
  getElement(testId: number) {
    return this.get('certificateElement?certificateId=' + testId);
  }

  //#region certificate Dasboard

  getAllCertificatesDetails(params) {
    return this.get('certificate/getAllCertificate',params);
  }
  getCertificateCheckedBy() {
    return this.get('certificate/getCertificateCheckBy');
  }
  //#endregion certificate Dasboard

  saveDocuments(parameter: any[]) {
    return this.post('projectDocuments', parameter);
  }
  getResult(testId: number) {
    return this.get('constructionElement/GetElementResult?module=3&entity=' + testId);
  }
  getElementResult(testId: number) {
    return this.get('constructionElement/GetCertificateResult/' + testId);
  }

  getCertificateResult(cerId: number) {
    return this.get('constructionElement/getGoalResult?module=3&entityId=' + cerId);
  }
  saveGoalresult(data: any) {
    return this.post('constructionElement/GoalResultCert', data);
  }
  deletePerformance(ids: number[], elemenetId) {
    return this.post('constructionElement/' + elemenetId + '/Delete', ids);
  }
  search(data: CertiticateFilterDTO) {
    return this.post('certificate/search/', data);
  }

   export(data: CertiticateFilterDTO) {
      return this.getFile<any>('certificate/export', data);
    }
  
  
  copy(data: any) {
    return this.post('certificate/copy/', data);
  }

  deleteCertificate(id: number, projectId: number) {
    return this.delete(`certificate/${id}/${projectId}`);
  }

}
